import {createStackNavigator as createStackNavigatorOriginal} from '@react-navigation/stack';
export const createStackNavigator = createStackNavigatorOriginal;
